// extracted by mini-css-extract-plugin
export var actualiteCarouselDotsWrapper = "actualites-module--actualite-carousel-dots-wrapper--35c1b";
export var actualiteCategorie = "actualites-module--actualite-categorie--a7f75";
export var actualiteContainer = "actualites-module--actualiteContainer--8ec42";
export var actualiteContainerFirst = "actualites-module--actualiteContainerFirst--43c50";
export var actualiteImgContainer = "actualites-module--actualite-img-container--5aeb0";
export var actualiteInfos = "actualites-module--actualite-infos--7cd4e";
export var actualiteResponsive = "actualites-module--actualite-responsive--6cd54";
export var actualiteResume = "actualites-module--actualite-resume--33e1a";
export var actualiteTitle = "actualites-module--actualite-title--8b0d8";
export var actualitesContainer = "actualites-module--actualites-container--49630";
export var actualitesDescription = "actualites-module--actualites-description--4c593";
export var autresActualites = "actualites-module--autres-actualites--68012";
export var autresActualitesResponsiveOnly = "actualites-module--autres-actualites-responsive-only--c2bf7";
export var editButton = "actualites-module--edit-button--206a8";
export var editButtonFirstActu = "actualites-module--edit-button-first-actu--2e904";
export var editButtonTitle = "actualites-module--edit-button-title--34f22";
export var listActualitesContainer = "actualites-module--list-actualites-container--81839";
export var listActualitesHeaderContainer = "actualites-module--list-actualites-header-container--681b9";
export var listActualitesTitle = "actualites-module--list-actualites-title--4ae4a";
export var toutesNosActusResponsiveOnly = "actualites-module--toutes-nos-actus-responsive-only--6371e";